import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart-empty",
  "use": "icon-heart-empty-usage",
  "viewBox": "0 0 26 22",
  "content": "<symbol viewBox=\"0 0 26 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-heart-empty\">\n<path d=\"M25 7.79531C25 3.66667 22.3328 1 18.6327 1C15.6649 1 14.3313 2.33333 13 4.49473C11.6641 2.33333 10.3305 1 7.36735 1C3.71098 1 1.00003 3.66667 1 7.79531C0.999961 13.9837 11.6641 21 12.9977 21C14.3313 21 25 14.3333 25 7.79531Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol